import React from 'react';
// It's important to write Documentation!!!

class HeaderText extends React.Component {
    render() {
        return (
            <div>
                <h1>Search our past grants log</h1>
                <p>There is only a sample set here to demonstrate experience o fthe user interface.</p>
           </div>
        )
    }
}

export default HeaderText;